<template>
    <div class="sign">
        <div class="sign-cont">
            <div class="title">
                找回密码
            </div>
            <div class="errorMsg">
                {{errorMsg}}
            </div>
            <form class="sign-form" style="background: #fff;padding-bottom: 40px;">
                <div class="input-div">
                    <i class="iconfont icon-people"></i>
                    <input type="number" placeholder="请输入手机号码" v-model="user.phone" @input="inputPhone()">
                </div>
                <div class="input-div identify-code-div">
                    <input type="text" placeholder="输入验证码" maxlength="6" v-model="user.code" @keyup="$event,'lookPwd'">
                    <button class="submit-btn" @click="getCode('lookPwd')" type="button" :disabled="timer?true:false">
                        <span v-if="!timer">
                            {{hasSendMsg?'重新发送':'获取验证码'}}
                        </span>
                        <span v-else>{{timer}}s 重新发送</span>
                    </button>
                </div>
                <div class="input-div">
                    <i class="iconfont icon-lock"></i>
                    <input type="password" placeholder="设置密码 (6～20 位)" v-model="user.password">
                </div>
                <div>
                    <button class="green-btn" @click="lookPwd" style="width:240px;" type="button">确定</button>
                </div>
                <div class="sign-href">
                    <a href="javascript:void(0)" @click="goSign()" class="underline-href main-font-color">前往注册</a>
                </div>
            </form>
        </div>
        <Modal v-model="imgValidator" class="imgValidator" width="360">
            <div class="close-btn" slot="close">
                <i class="iconfont icon-pop-close"></i>
            </div>
            <div slot="header" class="title">请输入验证码</div>
            <img-validate-modal   ref="imgValidator" :phone="user.phone" @sendMsg="sendMsgBegin"></img-validate-modal>
        </Modal>
    </div>
</template>
<script>
    import api from '../../../api';
    import validator from './validator';
    import imgValidateModal from './imgValidateModal.vue'

    const reg_phone = validator.reg_phone;
    const reg_code = validator.reg_code;
    const reg_password = validator.reg_password;
    export default{
        data(){
            return {
                errorMsg:'',
                imgValidator:false,
                user:{
                    phone:this.$route.query.phone||''
                },
                hasSendMsg:false,
                timer:0,
                timerInterval:()=>{}
            }
        },
        components:{
            'img-validate-modal':imgValidateModal
        },
        methods:{
            inputPhone(){
                this.user.phone = Number(String(this.user.phone).slice(0,11));
            },
            setToken(token){
                this.$store.dispatch('setToken',token);
            },
            getCode(){
                if(this.user.phone){
                    if(!reg_phone.test(this.user.phone)){
                        this.errorMsg = '您输入的手机号不符合规则';
                        return;
                    }else{
                        api.account.checkPhoneExist({
                            phone:this.user.phone
                        })
                        .then((res)=>{
                            if(!res){
                                this.errorMsg = '该手机号还未注册,请前往注册';
                            }else{
                                this.$refs.imgValidator.open('lookPwd');
                                this.imgValidator = true;
                            }
                        });
                    }
                }else{
                    this.errorMsg = '手机号必填';
                    return;
                }
            },
            sendMsgBegin(){
                this.closeImgValidator();
                !this.hasSendMsg&&(this.hasSendMsg = true);
                let that = this;
                that.timer = 60;
                that.timerInterval = setInterval(function(){
                    that.timer--;
                    if(that.timer==0){
                        clearInterval(that.timerInterval);
                    }
                },1000);
            },
            lookPwd(){
                if(this.validate()){
                    api.account.lookPassword({
                        'phone':this.user.phone,
                        'password':this.user.password,
                        'code':this.user.code
                    })
                        .then((res)=>{
                            api.account.login({
                                'phone':this.user.phone,
                                'password':this.user.password
                            })
                            .then((res)=>{
                                this.setToken(res);
                                this.$router.push({name:'lookPwdSuc'});
                            });
                        },(error)=>{
                            this.errorMsg = error.data.message;
                        });
                }
            },
            validate(){
                if(this.user.phone){
                    if(!reg_phone.test(this.user.phone)){
                        this.errorMsg = '您输入的手机号不符合规则';
                        return false;
                    }
                }else{
                    this.errorMsg = '手机号必填';
                    return false;
                }
                if(this.user.password){
                    if(!reg_password.test(this.user.password)){
                        this.errorMsg = '您输入的密码不符合规则';
                        return false;
                    }
                }else{
                    this.errorMsg = '密码必填';
                    return false;
                }
                if(!this.user.code){
                    this.errorMsg = '验证码必填';
                    return false;
                }
                this.errorMsg = '';
                return true;
            },
            keyup(e,func){
                if(e.keyCode==13){
                    this[func]();
                }
            },
            goSign(){
                this.$router.push({name:'sign',query:{tab:'sign',phone:this.user.phone}});
            },
            closeImgValidator(){
                this.imgValidator = false;
            }

        }
    }
</script>
<style scoped>
    .sign-cont .m-box{
        width:640px;
    }
    .sign-cont .title{
        height:68px;
        line-height: 68px;
        border-bottom:2px solid #F2F4F5;
        font-size: 20px;
        color: #555555;
    }
</style>